import React from 'react';

interface WaveBandProps {
  /** Use the muted variant when the band sits on the navy chrome. */
  variant?: 'light' | 'navy';
  tall?: boolean;
  className?: string;
}

/**
 * The scallop pattern from the logo, repeated as a horizontal rule.
 * Purely decorative, so it is hidden from assistive tech.
 */
const WaveBand: React.FC<WaveBandProps> = ({ variant = 'light', tall = false, className = '' }) => (
  <div
    aria-hidden="true"
    className={[
      'wave-band',
      variant === 'navy' ? 'wave-band--navy' : '',
      tall ? 'wave-band--tall' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  />
);

export default WaveBand;
